<div class="premium-searchbar">
    <app-smash-input type="text" placeholder="{{ 'PREMIUM_ADMIN_MEMBERS_TABLE_SEARCH_MEMBER_PLACEHOLDER' | translate }}" [(ngModel)]="search" name="searchValueMember">
    </app-smash-input>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1>
                {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_TITLE_MEMBER_LIST' | translate }}
            </h1>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshMembers()">
                <i class="icon-smash_remote"></i>
            </div>
            <app-smash-csv-export
                [data]="csvExportData$ | async"
                filename="members-export"
                buttonLabel="PREMIUM_ADMIN_MEMBERS_TABLE_BUTTON_LABEL_EXPORT_CSV">
            </app-smash-csv-export>
            <button class="btn-new red" (click)="openModalAddMember()">
                {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_BUTTON_LABEL_ADD_MEMBER' | translate }}
            </button>
            <button class="btn-new red" (click)="openModalImportMembers()">
                {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_BUTTON_LABEL_IMPORT_MEMBERS' | translate }}
            </button>
        </div>
    </div>
    <ng-container *ngIf="(membersLoading$ | async); else membersLoaded">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #membersLoaded>
        <div class="premium-card-center">
            <ng-container *ngIf="(members$ | async)?.length; else noMembers">
                <app-smash-data-table [data]="(members$ | async)" [searchValue]="search" [columns]='columnsEnabled' enableMoreOptions='true' [enableColumnOptions]='false'
                    rowClickable='true' (rowClicked)="viewMemberDetails($event.id)" [paginationEnabled]="true">
                    <ng-template #optionsList let-item>
                        <li (click)="viewMemberDetails(item.id)">
                            <a>
                                {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_OPTION_LABEL_EDIT_MEMBER' | translate }}
                            </a>
                        </li>
                        <li (click)="inviteMemberDetails(item.id)" *ngIf="!item.provisioned">
                            <a>
                                {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_OPTION_LABEL_INVITE_MEMBER' | translate }}
                            </a>
                        </li>
                        <li (click)="openModalDeleteMember(item)" *ngIf="!item.provisioned || item.status === 'Disabled'">
                            {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_OPTION_LABEL_DELETE_MEMBER' | translate }}
                        </li>
                    </ng-template>
                </app-smash-data-table>
            </ng-container>
            <ng-template #noMembers>
                <div class="premium-card-center-no-content">
                    <span class="premium-card-center-no-content-message">
                        {{ 'PREMIUM_ADMIN_MEMBERS_TABLE_NO_MEMBER' | translate }}
                    </span>
                </div>
            </ng-template>
        </div>
    </ng-template>
</div>